import { render, staticRenderFns } from "./card-situation-resource.vue?vue&type=template&id=281e30d9&"
import script from "./card-situation-resource.vue?vue&type=script&lang=js&"
export * from "./card-situation-resource.vue?vue&type=script&lang=js&"
import style0 from "./card-situation-resource.vue?vue&type=style&index=0&id=281e30d9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports